/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/.4.17.4@lodash/_freeGlobal.js
// module id = 229
// module chunks = 0 1